import EventsList from ".";
import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import ManageEvent from "../../../../../components/sections/admin/Event/ManageEvent";
import EventCategory from "../EventCategory";
import EventTags from "../EventTags";

const tabRoutes = [
  {
    label: "List",
    icon: "fa-regular fa-icons",
    path: "/admin/events",
  },
  {
    label: "Categories",
    icon: "fa-regular fa-layer-group",
    path: "/admin/event-categories",
  },
  {
    label: "Tags",
    icon: "fa-regular fa-tags",
    path: "/admin/event-tags",
  },
  {
    label: "Comments",
    icon: "fa-regular fa-comments",
    path: "/admin/events-comment",
  },
];

export const eventRoutes = () => [
  {
    path: "/admin/events",
    component: () => (
      <TabsNavigation title="Events Management" tabRoutes={tabRoutes}>
        <EventsList />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Events Management",
  },
  {
    path: "/admin/event-categories",
    component: () => (
      <TabsNavigation title="Events Management" tabRoutes={tabRoutes}>
        <EventCategory />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Events Management",
  },
  {
    path: "/admin/event-tags",
    component: () => (
      <TabsNavigation title="Events Management" tabRoutes={tabRoutes}>
        <EventTags />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Events Management",
  },
  {
    path: "/admin/manage-events",
    component: ManageEvent,
    layout: "admin",
    routeType: "admin",
    title: "Manage Events",
  },
  {
    path: `/admin/manage-events/:id`,
    component: ManageEvent,
    layout: "admin",
    routeType: "admin",
    title: "Manage Events",
  },
];
